export default __webpack_public_path__ + "static/media/Card_Pine_Lab_Excel_File_Preveiw.17d8150d.png";